'use client';

import { useContext } from 'react';
import { Controller } from 'react-hook-form';
import { AmountRadio } from '@/shared/ui/amount-radio';
import { RadioGroupRootContext } from './form-radio-group';
import { FormFieldProps } from './types';
import { mergeRefs } from './utils/mergeRefs';
import { parseRulesForInputAttributes } from './utils/parseRulesForInputAttributes';

type Props = Omit<FormFieldProps<typeof AmountRadio>, 'name'>;
export const FormAmountRadio = ({
    id,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    ref,
    value,
    ...props
}: Props) => {
    const { name } = useContext(RadioGroupRootContext);
    return (
        <Controller
            {...{ name, control, defaultValue, disabled, rules, shouldUnregister }}
            render={({ field: { ref: fieldRef, ...field } }) => {
                return (
                    <AmountRadio
                        ref={mergeRefs([fieldRef, ref])}
                        id={id || name}
                        checked={value === field.value}
                        value={value}
                        {...parseRulesForInputAttributes(rules)}
                        {...props}
                    />
                );
            }}
        />
    );
};
